var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container conteudo"},[_c('b-breadcrumb',{attrs:{"items":this.$route.meta.breadcrumb}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }